export default __webpack_public_path__ + "static/BrownEntrataWeb-Italic-4a6a649413ef07fa79db6f49097e0692.woff";